<script setup>
import { computed } from 'vue';

const props = defineProps({
  // Plain strings where the label is the value, or { value, label } pairs where
  // a filter needs a value the viewer never sees (e.g. 'none' shown as 'No broker').
  options: { type: Array, required: true },
  modelValue: { type: [String, Number], default: '' },
  ariaLabel: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const normalised = computed(() => props.options.map((option) => (
  typeof option === 'object' && option !== null
    ? { value: option.value, label: option.label }
    : { value: option, label: option }
)));
</script>

<template>
  <select
    class="xl-select"
    :value="props.modelValue"
    :aria-label="props.ariaLabel || undefined"
    @change="emit('update:modelValue', $event.target.value)"
  >
    <option v-for="option in normalised" :key="option.value" :value="option.value">{{ option.label }}</option>
  </select>
</template>

<style scoped>
.xl-select, .xl-select * { box-sizing: border-box; }

.xl-select {
  height: 42px;
  width: auto;
  max-width: 100%;
  padding: 0 34px 0 14px;
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-sm);
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M5 7.5 10 12.5 15 7.5' stroke='%23867D8D' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 11px center;
  font-family: var(--xl-font-family);
  font-size: var(--xl-font-size-base);
  color: var(--xl-color-primary-text);
  appearance: none;
  cursor: pointer;
}

.xl-select:focus {
  outline: none;
  border-color: var(--xl-color-primary);
  box-shadow: 0 0 0 3px rgba(94, 47, 120, 0.1);
}
</style>
